import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

export const Connectivity = ({ className = "mx-auto" }) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const circlesRef = useRef<(SVGCircleElement | null)[]>([]);

  useGSAP(() => {
    const svg = svgRef.current;
    const circles = circlesRef.current.filter(Boolean);

    if (!svg || !circles.length) return;

    // Create infinite loop timeline
    const tl = gsap.timeline({ repeat: -1, repeatDelay: 0.8 });

    // Set initial state
    gsap.set(svg, {
      transformOrigin: "center center",
      rotation: 0,
    });

    gsap.set(circles, {
      opacity: 0,
    });

    // Animate with staggered fade-in for circles and rotation for entire SVG
    tl
      // Staggered fade in for circles
      .to(circles, {
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        stagger: 0.08, // 80ms delay between each circle
      })
      // Rotate entire SVG while circles are visible
      .to(
        svg,
        {
          rotation: 360,
          duration: 4,
          ease: "power1.inOut",
        },
        "-=0.3"
      )
      // Hold for a moment
      .to({}, { duration: 0.3 })
      // Staggered fade out for circles
      .to(circles, {
        opacity: 0,
        duration: 0.4,
        ease: "power2.in",
        stagger: 0.08,
      })
      // Reset rotation
      .set(svg, { rotation: 0 });
  });

  return (
    <svg
      ref={svgRef}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 200 200"
      width={150}
      height={150}
      className={className}
    >
      <g>
        <circle
          ref={(el) => {
            circlesRef.current[0] = el;
          }}
          fill="#fee6de"
          cx="99.89"
          cy="30.76"
          r="24.99"
        />
        <circle
          ref={(el) => {
            circlesRef.current[1] = el;
          }}
          fill="#85cdb5"
          cx="99.89"
          cy="169.24"
          r="24.99"
        />
      </g>
      <g>
        <circle
          ref={(el) => {
            circlesRef.current[2] = el;
          }}
          fill="#f5f7dd"
          cx="148.85"
          cy="51.04"
          r="24.99"
        />
        <circle
          ref={(el) => {
            circlesRef.current[3] = el;
          }}
          fill="#43b0da"
          cx="50.93"
          cy="148.96"
          r="24.99"
        />
      </g>
      <g>
        <circle
          ref={(el) => {
            circlesRef.current[4] = el;
          }}
          fill="#a4d5ab"
          cx="148.85"
          cy="148.96"
          r="24.99"
        />
        <circle
          ref={(el) => {
            circlesRef.current[5] = el;
          }}
          fill="#0d2949"
          cx="50.93"
          cy="51.04"
          r="24.99"
        />
      </g>
      <g>
        <circle
          ref={(el) => {
            circlesRef.current[6] = el;
          }}
          fill="#daeddc"
          cx="169.24"
          cy="100"
          r="24.99"
        />
        <circle
          ref={(el) => {
            circlesRef.current[7] = el;
          }}
          fill="#0d7da0"
          cx="30.76"
          cy="100"
          r="24.99"
        />
      </g>
    </svg>
  );
};
